var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { I18NLink, Translate } from "../../I18N";
import { NeedAuthorization } from "../../Auth";
import { Icon } from "../../UI";
import { PreserveIcon } from "../../Layout/PreserveIcon";
import { FeatureToggle } from "../../components/Elements/FeatureToggle";
import { connect } from 'react-redux';

const SettingsNavigationComponent = ({ allowcustomJS }) => /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
_jsx("div", { className: "panel-heading" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Settings")
), /*#__PURE__*/
_jsx("div", { className: "list-group" }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/account", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Account")
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/dashboard", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Dashboard")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/users", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Users & Groups")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/collection", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Collection")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/navlinks", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Menu")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/pages", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Pages")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/languages", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Languages")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/translations", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Translations")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/filters", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Filters configuration")
)
)
)
), /*#__PURE__*/
_jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx("div", { className: "panel-heading" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Metadata")
)
), /*#__PURE__*/
_jsx("div", { className: "list-group" }, void 0, /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/templates", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Templates")
)
), /*#__PURE__*/
_jsx(FeatureToggle, { feature: "metadataExtraction.url" }, void 0, /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, {
  to: "settings/metadata_extraction",
  activeclassname: "active",
  className: "list-group-item" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Metadata Extraction")
)
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/dictionaries", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Thesauri")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/connections", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Relationship types")
)
)
), /*#__PURE__*/

_jsx("div", { className: "panel-heading" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Tools")
), /*#__PURE__*/
_jsx("div", { className: "list-group" }, void 0, /*#__PURE__*/
_jsx(FeatureToggle, { feature: "preserve.host" }, void 0, /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "/settings/preserve", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Preserve"), /*#__PURE__*/
_jsx(PreserveIcon, {})
)
)
), /*#__PURE__*/
_jsx(FeatureToggle, { feature: "newRelationships" }, void 0, /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, {
  to: "/settings/newrelmigration",
  activeclassname: "active",
  className: "list-group-item",
  "no-translate": true }, void 0,
"New Relationships Migration"

)
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/activitylog", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Activity log")
), /*#__PURE__*/
_jsx(I18NLink, {
  to: "/settings/customisation",
  activeclassname: "active",
  className: "list-group-item" }, void 0,

allowcustomJS ? /*#__PURE__*/
_jsx(Translate, {}, void 0, "Global CSS & JS") : /*#__PURE__*/

_jsx(Translate, {}, void 0, "Global CSS")

), /*#__PURE__*/
_jsx(I18NLink, {
  to: "/settings/custom-uploads",
  activeclassname: "active",
  className: "list-group-item" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Uploads")
)
), /*#__PURE__*/
_jsx("a", {
  className: "list-group-item",
  href: "https://uwazi.readthedocs.io/en/latest/",
  target: "_blank",
  rel: "noopener noreferrer" }, void 0, /*#__PURE__*/

_jsx("span", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Documentation"), " ", /*#__PURE__*/_jsx(Icon, { icon: "external-link-alt" })
)
)
)
)
);


export const mapStateToProps = (state) => ({
  allowcustomJS: Boolean(state.settings.collection.get('allowcustomJS'))
});

export const SettingsNavigation = connect(mapStateToProps)(SettingsNavigationComponent);